var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuJiaoshigongchuang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72168 2.37891C10.8778 1.87317 13.1222 1.87317 15.2783 2.37891C18.4253 3.11718 20.8828 5.5747 21.6211 8.72168C22.1268 10.8777 22.1268 13.1222 21.6211 15.2783C20.8828 18.4253 18.4253 20.8828 15.2783 21.6211C13.1222 22.1268 10.8778 22.1268 8.72168 21.6211C5.5747 20.8828 3.11718 18.4253 2.37891 15.2783C1.87317 13.1222 1.87317 10.8778 2.37891 8.72168C3.11719 5.57473 5.57473 3.11719 8.72168 2.37891ZM4.1836 9.87891C3.89814 11.5168 3.94539 13.1979 4.32618 14.8213C4.89093 17.2289 6.77105 19.1091 9.17872 19.6738C9.77955 19.8148 10.3885 19.9083 11 19.958V9.87891H4.1836ZM13 16.1211V19.958C13.6116 19.9083 14.2205 19.8148 14.8213 19.6738C16.7752 19.2155 18.3818 17.8909 19.2197 16.1211H13ZM13 14.1211H19.8164C20.1019 12.4832 20.0546 10.8021 19.6738 9.17872C19.1091 6.77105 17.2289 4.89093 14.8213 4.32618L14.4229 4.24024C13.9519 4.14606 13.4768 4.0798 13 4.04102V14.1211ZM11 4.04102C10.3884 4.09058 9.77955 4.18524 9.17872 4.32618C7.22482 4.7845 5.61825 6.10908 4.78028 7.87891H11V4.04102Z",
    fill: "#091B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuJiaoshigongchuang);
export default __webpack_public_path__ + "static/media/menu_jiaoshigongchuang.d0a5fa1306a718079a200ff442fed265.svg";
export { ForwardRef as ReactComponent };